/**
 * TRCE Phase 6 — L15 White Label client types.
 */
export type TrceWhiteLabelTenant = {
  operatorId: number;
  operatorSlug: string;
  operatorName: string;
  moduleKey: string;
  assignmentMode: string;
  brandOverride: {
    appName: string | null;
    appNameEn: string | null;
    logoUrl: string | null;
    primaryColor: string | null;
    hideTasallotBrand: boolean;
  } | null;
};

export type TrceWhiteLabelSlice = {
  profileKey: string;
  orchestrationMode: "platform" | "operator" | "multi_tenant";
  hideTasallotBrand: boolean;
  customDomain: string | null;
  activeTenant: TrceWhiteLabelTenant | null;
  tenants: TrceWhiteLabelTenant[];
  moduleOperators: Record<string, { operatorId: number; operatorSlug: string; operatorName: string; mode: string }>;
  count: number;
  sources: string[];
};

export function applyWhiteLabelDocumentBranding(slice: TrceWhiteLabelSlice | null): void {
  if (!slice?.activeTenant?.brandOverride) return;
  const b = slice.activeTenant.brandOverride;
  const appName = b.appNameEn ?? b.appName;
  if (appName) {
    try {
      document.title = appName;
    } catch { /* ignore */ }
  }
  if (b.primaryColor) {
    try {
      document.documentElement.style.setProperty("--runtime-primary", b.primaryColor);
      const meta = document.querySelector('meta[name="theme-color"]');
      if (meta) meta.setAttribute("content", b.primaryColor);
    } catch { /* ignore */ }
  }
  if (b.logoUrl) {
    try {
      let link = document.querySelector('link[rel="icon"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = b.logoUrl;
    } catch { /* ignore */ }
  }
}
